/*
 * @Author: Lemon C
 * @Date: 2024-05-30 15:48:07
 * @LastEditTime: 2025-09-17 10:54:26
 */
import { defineStore } from 'pinia';
import merge from 'webpack-merge'; //链接增加参数
import globalObj from '../utils/globalObj';
import CryptoJS from 'crypto-js';

let state_store;
async function getStateStore() {
    // 异步导入
    const { useStateStore } = await import('@/stores/state');
    state_store = useStateStore();
}
getStateStore();

let user_store;
async function getUserStore() {
    // 异步导入
    const { useUserStore } = await import('@/stores/user');
    user_store = useUserStore();
}
getUserStore();

let message_store;
async function getMessageStore() {
    // 异步导入
    const { useMessageStore } = await import('@/stores/message');
    message_store = useMessageStore();
}
getMessageStore();

export const useRouterStore = defineStore('router', {
    state: () => ({
        // 在这里可以定义一些路由相关的状态
    }),
    actions: {
        // MARK 路由产生变化
        pathChange(to, from) {
            this.checkPathState();

            // 判断是否是从文档返回其他页面，文档因为先调整对应类型，再点击目录树，链接会变话两次，这种情况的放回需要返回两次
            if (to.path === from.path && to.query && from.query && !to.query.treeId && from.query.treeId) {
                this.router.go(-1);
            }

            // 判断是否是当前文档的id切换用于退出操作，文档的切换不是浏览器加载而是内容信息的变化，所以不会触发vue的刷新，
            // 手动点击目录树，这样的操作会导致多次点击获取数据，因为路由信息变化，并不知道是后退还是切换
            if (to.path === from.path && to.query && from.query && to.query.treeId && from.query.treeId && to.query.treeId != from.query.treeId) {
                message_store.sendMessage(message_store.M_E_TREE_AUTO_SEL, to.query);
            }
        },

        // MARK 检查路由状态
        checkPathState() {
            const path = this.route.path;
            // 标记导航类型
            let router_obj = globalObj.router_nav_path.find((item) => item.path === path);
            state_store.nav_type = router_obj.type;
            state_store.updateState();
        },

        navigateTo(path, query = {}) {
            // 执行路由跳转
            this.router.push({ path: path, query });
        },

        windowOpen(path, query = {}) {
            // 跳转新窗口
            const routeData = this.router.resolve({ path: path, query: query });
            window.open(routeData.href, '_blank');
        },

        navigateToAnyDoc(type, query = {}) {
            let router_obj = globalObj.router_path.find((item) => item.type === type);
            router_obj && this.windowOpen(router_obj.url, query);
        },

        navigateToLinkHref(href, callback) {
            // 使用 URL 对象解析
            const url = new URL(href);
            const path = url.hash.slice(1).split('?')[0];
            const queryParams = new URLSearchParams(url.hash.slice(1).split('?')[1]);
            const query = Object.fromEntries(queryParams.entries());

            let internalLink = Object.values(globalObj.router_type).find((value) => value.includes(path));
            if (path && path.length > 0 && internalLink) {
                // 内部链接
                if (query.treeId && query.shareType && this.route.query.treeId && this.route.query.shareType && internalLink === this.route.path) {
                    if (callback) {
                        callback(query); // 外部自行处理当前页面的跳转
                    } else {
                        this.windowOpen(internalLink, query);
                    }
                } else {
                    this.windowOpen(internalLink, query);
                }
            } else {
                window.open(href, '_blank');
            }
        },

        navigateToHome(query = {}) {
            this.navigateTo(globalObj.router_type.home, query);
        },

        navigateToServiceApi(query = {}) {
            this.navigateTo(globalObj.router_type.service, query);
        },

        navigateToJsApi(query = {}) {
            this.navigateTo(globalObj.router_type.js, query);
        },

        navigateToIOSApi(query = {}) {
            this.navigateTo(globalObj.router_type.ios, query);
        },

        navigateToAndroidApi(query = {}) {
            this.navigateTo(globalObj.router_type.android, query);
        },

        navigateToCourse(query = {}) {
            this.navigateTo(globalObj.router_type.course, query);
        },

        navigateToDemo(query = {}) {
            this.navigateTo(globalObj.router_type.demo, query);
        },

        navigateToGuide(query = {}) {
            this.navigateTo(globalObj.router_type.guide, query);
        },

        navigateToFaq(query = {}) {
            this.navigateTo(globalObj.router_type.faq, query);
        },

        navigateToToolUseGuide(query = {}) {
            this.navigateTo(globalObj.router_type.toolUseGuide, query);
        },

        navigateToUpdatelog(query = {}) {
            this.navigateTo(globalObj.router_type.updatelog, query);
        },

        navigateToSearch(query = {}) {
            this.windowOpen(globalObj.router_type.search, query);
        },

        navigateToMsg(query = {}) {
            this.windowOpen(globalObj.router_type.msg, query);
        },

        navigateToFuncDetail(query = {}) {
            this.windowOpen(globalObj.router_type.func_detail, query);
        },

        navigateToFuncList(query = {}) {
            this.windowOpen(globalObj.router_type.func_list, query);
        },

        navigateToCantactUs(query = {}) {
            this.navigateTo(globalObj.router_type.contact_us, query);
        },

        windowOpenTo(path) {
            window.open(path, '_blank');
        },

        windowOpenToBilibli() {
            window.open('https://space.bilibili.com/1468997385/lists/4500430?type=season', '_blank');
        },

        // MARK 配置浏览器地址栏路由
        configBrowserAddressRoute(query = {}) {
            // 配置当前路由（用于分享）
            this.router.push({
                query: merge(query),
            });
        },

        // MARK 跳转转换平台携带登录信息
        // type 0: 登录 1：忘记密码 2：注册
        windowOpenPlatform(type = 0) {
            // 获取登录信息（tokenId）
            const tokenId = user_store.tokenId;
            var url = '';
            if (tokenId && tokenId.length > 0) {
                const tokenId_aes = CryptoJS.AES.encrypt(tokenId, globalObj.config.__login_token_enc).toString();
                const tokenId_enc = encodeURIComponent(tokenId_aes);
                url = `${window.platformUrl}?tokenId=${tokenId_enc}`;
            } else {
                if (type == 1) {
                    url = `${window.platformUrl}?loginMode=forget`;
                } else if (type == 2) {
                    url = `${window.platformUrl}?loginMode=register`;
                } else {
                    url = `${window.platformUrl}`;
                }
            }
            window.open(url, '_blank');
        },
    },
});
